import { BaseResponseType } from "@/types/message";
import http from "./httpVideo";
import { questionRequestUrls } from "@/utils/messageUrl";

const baseUrlResource = "/buyer";

const { get, post } = http;

export const saveQuestions = (params: any) => post(`${questionRequestUrls.saveQuestion}`, params);

export const getQuestions = (params: any) =>
  get(
    `/community-api/community/questAndAnswer/list?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&keyword=${params.keyword}&typeId=${params.typeId}`
  );

export const getQuestionById = (params: any) => get(`/community-api/community/questAndAnswer/detail/${params}`);

export const addViewCount = (params: any) => {
  return get(`/community-api/community/questAndAnswer/addViewCount?questionId=${params}&count=1`);
};



/**
 * 获取问题分类
 * @param params 
 * @returns 
 */
export const getQuestionCategory = () => {
  return get(`/community-api/community/questAndAnswer/type/list`);
};

/**
 * 上传图片
 * @param params 
 * @param config 
 * @returns 
 */
export const uploadFile = (params: any,config:any):Promise<BaseResponseType> => {
  return post(`${questionRequestUrls.uploadFile}`, params,config);
}

/**
 * 删除上传的文件
 * @param ids 
 * @returns 
 */
export const deleteFile = (ids: string) :Promise<BaseResponseType>=> {
  return http.delete(`${questionRequestUrls.deleteFile}/${ids}`);
}

/**
 * 问答 点赞
 * @param params 
 * @returns 
 */
export const addThumbsUp=(params:any)=>{
  return post(`${questionRequestUrls.addThumbsUp}`,params)
}

/**
 * 取消点赞
 * @param id 
 * @returns 
 */
export const cancelThumbsUp=(id:any)=>{
  return get(`${questionRequestUrls.cancelThumbsUp}?sourceId=${id}`)
}


/**
 * 获取用户提问的问题列表
 * @param params 
 * @returns 
 */
export const getQuestionUserList=(params:any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.getQuestionUserList}`,params)
}

/**
 * 获取通知公告列表
 * @param params 
 * @returns 
 */
export const getNoticeList=(params:any):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getNoticeList}`, {params})
}

/**
 * 获取通知公告详情
 * @param id 
 * @returns 
 */
export const getNoticeDetail=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getNoticeDetail}/${id}`)
}

/**
 * 获取常见Q&A列表
 * @param params 
 * @returns 
 */
export const getFAQList=(params:any):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getFAQList}`, {params})
}

/**
 * 获取常见Q&A详情
 * @param id 
 * @returns 
 */
export const getFAQDetail=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getFAQDetail}/${id}`)
}

// 获取faq类型列表
export const getFAQTypeList=():Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getFAQTypeList}`)
}

// 获取通知公告类型列表
export const getNoticeTypeList=():Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.getNoticeTypeList}`)
}

// 添加通知公告浏览量
export const addNoticeViewCount=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.addNoticeViewCount}?id=${id}&count=1&noticeId=${id}`)
}

// 添加faq浏览量
export const addFaqViewCount=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.addFaqViewCount}?questionId=${id}&count=1`)
}

// 添加通知公告点赞
export const addNoticeThumbsUp=(params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.addNoticeThumbsUp}`, params)
}

// 取消通知公告点赞
export const cancelNoticeThumbsUp=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.cancelNoticeThumbsUp}?sourceId=${id}`)
}

// 添加faq点赞
export const addFaqThumbsUp=(params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.addFaqThumbsUp}`, params)
}

// 取消faq点赞
export const cancelFaqThumbsUp=(id: string):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.cancelFaqThumbsUp}?sourceId=${id}`)
}

// 添加收藏
export const addQuestionCollect = (params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.addQuestionCollect}`, params)
}
// 添加收藏
export const addNoticeCollect = (params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.addNoticeCollect}`, params)
}
// 添加收藏
export const addFaqCollect = (params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.addFaqCollect}`, params)
}

// 获取问题反馈回复列表
export const getQuestionComments = (id: string, params: any):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.questionCommentRecord}/${id}`, {params})
}

// 获取问题反馈回复列表
export const getFAQComments = (id: string, params: any):Promise<BaseResponseType>=>{
  return get(`${questionRequestUrls.faqCommentRecord}/${id}`, {params})
}

// 发表评论
export const handlePubQuestionComment = (params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.pubQuestionComment}`, params)
}

export const handlePubFaqComment = (params: any):Promise<BaseResponseType>=>{
  return post(`${questionRequestUrls.pubFaqComment}`, params)
}

export const deleteQuestionComment = (commentId: string) :Promise<BaseResponseType>=> {
  return http.delete(`${questionRequestUrls.deleteQuestionComment}/${commentId}`);
}

export const deleteFaqComment = (commentId: string) :Promise<BaseResponseType>=> {
  return http.delete(`${questionRequestUrls.deleteFaqComment}/${commentId}`);
}

export const isUserFavoriteQusetion = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.QuestionUserIsFavorite}?sourceId=${sourceId}`);
}
export const isUserFavoriteFaq = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.FaqUserIsFavorite}?sourceId=${sourceId}`);
}
export const isUserFavoriteNotice = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.NoticeUserIsFavorite}?sourceId=${sourceId}`);
}

export const isUserThumbsUpQuestion = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.QuestionUserIsThumbsUp}?sourceId=${sourceId}`);
}
export const isUserThumbsUpFaq = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.FaqUserIsThumbsUp}?sourceId=${sourceId}`);
}
export const isUserThumbsUpNotice = (sourceId: string) :Promise<BaseResponseType>=> {
  return get(`${questionRequestUrls.NoticeUserIsThumbsUp}?sourceId=${sourceId}`);
}

// 取消收藏
export const cancelFavorite = (type: 'questAndAnswer' | 'notice' | 'faq', sourceId: string) => {
  return get(`/community-api/community/${type}/cancelFavorite?sourceId=${sourceId}`);
};

// 举报评论
export const reportQuestion = (type: 'questAndAnswer' | 'faq', params: any) => {
  return post(`/community-api/community/${type}/comment/report`,params);
};

// 获取举报类型
export const getReportType = () => {
  return get(`/community-api/community/commentReportType/list`);
};